import React from 'react';

import { IconButton, VerticalAlignBottomIcon } from '@gogame/components';
import { useScreenModalV2 } from '@gogame/screens';

import { useGroup } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Group';
import { usePlanApplyMetricBellow } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/PlanState';
import {
  useViewStateByPath,
  useViewStateByResolveName,
} from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';
import { ACTIVITY_TYPES_LABELS } from 'scenes/MarketingPlanning/MarketingPlanningWizard/constants';

import ConfirmApplyDialog from './ConfirmApplyDialog';

const MetricApplyBelowControl = ({ metric, disabled }) => {
  const { levelPath, activityType } = useGroup();
  const onApplyMetricBellow = usePlanApplyMetricBellow();
  const showApplyDialog = useScreenModalV2(ConfirmApplyDialog);

  const value = useViewStateByResolveName(metric);
  const { depth, metricTypes, ...levelValue } = useViewStateByPath(levelPath);

  const handleApplyMetricBellow = React.useCallback(async () => {
    await showApplyDialog({
      payload: {
        activityType,
        metric,
        value,
        depth,
        metricTypes,
        levelValue,
      },
    });
    onApplyMetricBellow({
      levelPath,
      activityType,
      metric,
      value,
    });
  }, [
    showApplyDialog,
    onApplyMetricBellow,
    activityType,
    metric,
    value,
    depth,
    metricTypes,
    levelValue,
  ]);

  const metricLabel = React.useMemo(
    () => metricTypes.find(({ id }) => id === metric)?.name,
    [metricTypes, metric]
  );

  return (
    <IconButton
      icon={<VerticalAlignBottomIcon />}
      onClick={handleApplyMetricBellow}
      tooltip={` Apply current ${ACTIVITY_TYPES_LABELS[activityType]} ${metricLabel} to all entities below `}
      disabled={disabled}
    />
  );
};

export default MetricApplyBelowControl;
